// Imports
import Axios from '@/config/AxiosConfig';

export const storeDocument = async (payload, from) => {
    // const mode = ;
    const url = `/${from}/store`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const updateDocument = async (payload, from) => {
    // let frm = from =='document-timeline' ? 'document-template':'document-timeline';
    const url = `/${from}/update`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const generateQrcode = async (payload) => {
    // let frm = from =='document-timeline' ? 'document-template':'document-timeline';
    const url = `setting/generate-qrcode`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const whatsappStatusDispatch = async (payload) => {
    const url = `setting/update-device-connection`;
    console.log(url, payload, 'whatsappStatusDispatch URL | payload');
    try {
        const { data } = await Axios.post(url, payload);
        console.log(data, 'whatsappStatusDispatch data');
        return data;
    } catch (e) {
        console.log(e)
        return e.response;
    }
};

export const getPreviewPDF = async (payload) => {
    const url = `/system-templates/temp-preview`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const getDocPreviewPDF = async (payload) => {
    const url = `/document-template/temp-preview`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const addDocumentSection = async (payload) => {
    const url = `/document-template/section/create`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const updateDocumentSection = async (payload) => {
    const url = `/document-template/update-section`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const getDocuments = async (status) => {
    const url = `document-template/${status}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const disableDocument = async (id) => {
    const url = `document-template/status/${id}/D`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const activeDocument = async (id) => {
    const url = `document-template/status/${id}/A`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
// system-templates
export const toggleSystemDocumentStatus = async (id, ststus) => {
    const url = `system-templates/status/${id}/${ststus}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};


export const activeDocumentSection = async (id) => {
    const url = `document-template/section/status/${id}/D`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const disableDocumentSection = async (id) => {
    const url = `document-template/section/status/${id}/A`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const getDocument = async (id, from) => {
    const url = `${from}/show/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// delete document
export const deleteDocument = async (id) => {
    const url = `document-template/delete/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// system-templates
export const deleteSystemDocument = async (id) => {
    const url = `system-templates/delete/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const copyDocument = async (id) => {
    const url = `document-template/duplicate/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
// system-templates
export const copySystemDocument = async (id) => {
    const url = `system-templates/duplicate/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const openSystemDocumentById = async (id) => {
    const url = `system-templates/show/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// export const getDocumentSection = async (id) => {
//     const url = `document-template/show/${id}`;
//     try{
//         const {data} = await Axios.get(url)
//         return data
//     }catch(e){
//         return e.response;
//     }
// }

export const sortTemplates = async (payload) => {
    const url = `document-template/sort-templates`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const sortSections = async (payload) => {
    const url = `document-template/sort-section`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};
export const getSmartTags = async (type, typeId) => {
    let url;
    if(type && typeId){
        url = `smart-tags/get/${type}/${typeId}`;
    } else if (type){
        url = `smart-tags/get/${type}`;
    }else {
        url = `smart-tags/get`;
    }
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

export const checkTemplateTags = async (id) => {
    const url = `document-timeline/check-template-tags?template_id=${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};

// get letter heads
// http://pms6-api.gnomen.io/api/v1/letter-heads/get-lh

export const getLetters = async () => {
    const url = 'letter-heads/get-lh';
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// letter heads preview
export const previewLetter = async (id) => {
    const url = `letter-heads/preview/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

//letter head duplicate
export const duplicateLetter = async (id) => {
    const url = `letter-heads/duplicate-letter-head/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// get edit letters data
export const getEditData = async (id) => {
    const url = `letter-heads/edit/${id}`;
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// delete letter heads
export const deleteLetter = async (payload) => {
    const url = `letter-heads/destroy`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// update letter heads
export const updateLetter = async (payload) => {
    const url = `letter-heads/update`;
    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// select letter head
export const selectLetterHead = async (id) => {
    try {
        const url = `letter-heads/select-design/${id}`;
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// revert to original letter head
export const revertLetterHead = async (id, type) => {
    try {
        const url = `letter-heads/default-content/${id}/${type}`;
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// print property calls start
// http://pms6-api.gnomen.io/api/v1/template/brochure/create-section
// add print property
export const addPrintPropertySection = async (payload) => {
    try {
        const url = `template/brochure/create-section`;
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// update print property
export const updatePrintPropertySection = async (payload) => {
    try {
        const url = `template/brochure/update-section`;
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// sort sections
export const sortPrintPropertySection = async (payload) => {
    try {
        const url = `template/brochure/sort-sections`;
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// sort documents 
export const sortDocumentsSection = async (payload) => {
    try {
        const url = `document-template/sort-section`;
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// sort brochures
export const sortPrintPropertyBrochures = async (payload) => {
    try {
        const url = `template/brochure/sort-brochures`;
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// get brouchures
export const getPrintPropertyBrochures = async () => {
    try {
        const url = `template/brochure/get`;
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// get brouchures data timeline
export const getPrintPropertyBrochuresData = async (brochureId, propertyId) => {
    try {
        const url = `timeline/get-brochure/${brochureId}/${propertyId}`;
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// change section status
export const changePrintPropertySectionStatus = async (action, id) => {
    try {
        const url = `template/brochure/change-section-status/${id}/${action}`;
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// delete section
export const deletePrintPropertySection = async (id) => {
    try {
        const url = `template/brochure/delete-section/${id}`;
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// delete broucher
export const deletePrintPropertyBrochure = async (id) => {
    try {
        const url = `template/brochure/delete-brochure/${id}`;
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// duplicate brouchers
export const duplicatePrintPropertybrochure = async (id) => {
    try {
        const url = `template/brochure/duplicate/${id}`;
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// edit brochure
export const editPrintPropertySection = async (id) => {
    try {
        const url = `template/brochure/get-brochure/${id}`;
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// update brochure
export const updatePrintPropertyBrochure = async (payload) => {
    try {
        const url = `template/brochure/update-brochure`;
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// upload brochure images
export const uploadPrintPropertyBrochureImages = async (payload) => {
    try {
        const url = `template/brochure/upload-images`;
        const { data } = await Axios.post(url, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return data;
    } catch (e) {
        console.log(e);
    }
};

// delete brochure images
export const deletePrintPropertyBrochureImages = async (id) => {
    try {
        const url = `template/brochure/delete-image/${id}`;
        const { data } = await Axios.delete(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// preview brochure
export const previewPrintPropertyBrochureImages = async (id) => {
    try {
        const url = `template/brochure/preview/${id}`;
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// add brochure on timeline
export const addPrintPropertyBrochureTimeline = async (payload) => {
    try {
        const url = `timeline/add-brochure`;
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// update brochure on timeline
export const updatePrintPropertyBrochureTimeline = async (payload) => {
    try {
        const url = `timeline/update-brochure`;
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        console.log(e);
    }
};

// System Template 
export const GetSystemTemplate = async () => {
    try{
        // http://pms6-api.gnomen.io/api/v1/system-templates
        const url = `system-templates`
        const { data } = await Axios.get(url);
        return data;
    }catch(e){
        console.log(e);
    }
}

export const DuplicateSystemTemplate = async (id) => {
    try{
        const url = `system-templates/duplicate/${id}`
        const { data } = await Axios.get(url);
        return data;
    }catch(e){
        console.log(e);
    }
}

export const DeleteSystemTemplate = async (payload) => {
    try{
        const url = `system-templates/destroy`
        const { data } = await Axios.post(url,payload);
        return data;
    }catch(e){
        console.log(e);
    }
}
export const PreviewSystemTemplate = async (id) => {
    try{
        const url = `system-templates/preview/${id}`
        const { data } = await Axios.get(url);
        return data;
    }catch(e){
        console.log(e);
    }
}

export const editSystemTemplate = async (id) => {
    try{
        const url = `system-templates/preview/${id}`
        const { data } = await Axios.get(url);
        return data;
    }catch(e){
        console.log(e);
    }
}

export const EditUpdateSystemTemplate = async (id,payload) => {
    try{
        const url = `system-templates/update`
        const { data } = await Axios.post(url,payload);
        return data;
    }catch(e){
        console.log(e);
    }
}




export const SystemTemplateSmartTag = async (type) => {
    try{
        const url = `system-templates/smart-tags/${type}`
        const { data } = await Axios.get(url);
        return data;
    }catch(e){
        console.log(e);
    }
}

// http://pms6-api.gnomen.io/api/v1/template/brochure/revert-to-original/4
// revert to original
export const revertToOriginalPrint = async (id) => {
    try{
        const url = `template/brochure/revert-to-original/${id}`
        const { data } = await Axios.get(url);
        return data;
    }catch(e){
        console.log(e);
    }
}

export const tempPreviewPrintProperty = async (payload) => {
    try{
        const url = `template/brochure/temp-preview`
        const { data } = await Axios.post(url, payload);
        return data;
    }catch(e){
        console.log(e);
    }
}

// chat bot api

// get all bots on setting page
export const getAllBots = async () => {
    try{
        const url = `chatbot/get-bots`
        const { data } = await Axios.get(url);
        return data;
    }catch(e){
        console.log(e);
    }
}

// get all bots on bot canvas
export const getAllBotsCanvas = async () => {
    try{
        const url = `chatbot/get-all-bots`
        const { data } = await Axios.get(url);
        return data;
    }catch(e){
        console.log(e);
    }
}

// create bot section 
export const createBotSection = async (payload) => {
    try{
        const url = `chatbot/create-section`
        const { data } = await Axios.post(url, payload);
        return data;
    }catch(e){
        console.log(e);
    }
}

// update bot section
export const updateBotSection = async (payload) => {
    try{
        const url = `chatbot/update-section`
        const { data } = await Axios.post(url, payload);
        return data;
    }catch(e){
        console.log(e);
    }
}

// sort bot sectoions
export const sortBotSection = async (payload) => {
    try{
        const url = `chatbot/sort-sections`
        const { data } = await Axios.post(url, payload);
        return data;
    }catch(e){
        console.log(e);
    }
}

// sort bots in settings
export const sortBot = async (payload) => {
    try{
        const url = `chatbot/sort-bots`
        const { data } = await Axios.post(url, payload);
        return data;
    }catch(e){
        console.log(e);
    }
}

// add bot 
export const addBot = async (payload) => {
    try{
        const url = `chatbot/add`
        const { data } = await Axios.post(url, payload);
        return data;
    }catch(e){
        console.log(e);
    }
}

// update bot
export const updateBot = async (payload) => {
    try{
        const url = `chatbot/update`
        const { data } = await Axios.post(url, payload);
        return data;
    }catch(e){
        console.log(e);
    }
}

// get single bot by id
export const getBot = async (id) => {
    try{
        const url = `chatbot/get-bot/${id}`
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
}

// delete bot
export const deleteBot = async (id) => {
    try{
        const url = `chatbot/delete-bot/${id}`
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
}
// duplicate bot
export const duplicateBot = async (id) => {
    try{
        const url = `chatbot/duplicate/${id}`
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
}

// change section status
export const changeBotSectionStatus = async (type, id) => {
    try{
        const url = `chatbot/change-section-status/${type}/${id}`
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
}

// change bot section status
export const changeBotStatus = async (type, id) => {
    try{
        const url = `chatbot/change-bot-status/${type}/${id}`
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
}

// change bot live status
export const changeBotLiveStatus = async (type, id) => {
    try{
        const url = `chatbot/change-bot-live-status/${type}/${id}`
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
}

// delete Section
export const deleteBotSection = async (id) => {
    try{
        const url = `chatbot/delete-section/${id}`
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
}

// nested get all bots
export const getNestedBots = async () => {
    try{
        const url = `chatbot/get-all-bots`
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
}

// get smart tags
export const getBotSmartTags = async (payload) => {
    try{
        const url = `chatbot/get-smart-tags/${payload}`
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
}

// get custom bot triggers
export const getBotTriggers = async (payload) => {
    try{
        const url = `chatbot/get-triggers${payload?'/'+payload:''}`
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
}

// get buffer time
export const getBotbuffer = async (triggerId) => {
    try{
        const url = `chatbot/get-times/${triggerId}`
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        console.log(e);
    }
}

// upload bot media images
export const uploadMediaBot = async (payload) => {
    try{
        const url = `chatbot/upload-media`
        const { data } = await Axios.post(url, payload);
        return data;
    }catch(e){
        console.log(e);
    }
}

// CHECK BUFFER EXIST
export const checkBuffer = async (payload) => {
    try{
        const url = `chatbot/check-buffer-exists`
        const { data } = await Axios.post(url, payload);
        return data;
    }catch(e){
        console.log(e);
    }
}

//Canned Responses
export const getAvailabilityOptions = async () => {
    try{
        const url = `group/list`
        const { data } = await Axios.get(url);
        return data;
    }catch(e){
        console.log(e);
    }
}

export const uploadFileOnServer = async (payload) => {
    try{
        const formData = new FormData()
        formData.append('files[0]', payload);
        formData.append('path', '');
        formData.append('source', '');
        const url = `timeline/upload-media`
        const { data } = await Axios.post(url, formData);
        return data;
    }catch(e){
        console.log(e);
    }
}


export const addCannedResponse = async (payload) => {
    try{
        const url = `canned-response/add`
        const { data } = await Axios.post(url, payload);
        return data;
    }catch(e){
        console.log(e);
    }
}

export const getCannedResponseList = async (searchQuery = '') => {
    let query = '';
    if(searchQuery) {
        query = `?search=${searchQuery}`
    }
    try{
        const url = `canned-response/get_list${query}`
        const { data } = await Axios.get(url);
        return data;
    }catch(e){
        console.log(e);
    }
}

export const getCannedResponse = async (id) => {
    try{
        const url = `/api/v1/canned-response/get/${id}`;
        const { data } = await Axios.get(url);
        return data;
    }catch(e){
        console.log(e);
    }
}

export const updateCannedResponse = async (payload) => {
    try{
        const url = `canned-response/update`
        const { data } = await Axios.post(url, payload);
        return data;
    }catch(e){
        console.log(e);
    }
}

export const deleteCannedResponse = async (id) => {
    try{
        const url = `canned-response/delete/${id}`
        const { data } = await Axios.get(url);
        return data;
    }catch(e){
        console.log(e);
    }
}